import React, { useState } from "react";
import NavHeader from "../components/NavHeader";
import HeroMast from "./components/HeroMast";
import TabBar from "./components/TabBar";
import HomeTab from "./tabs/HomeTab";
import PathsTab from "./tabs/PathsTab";
import InterviewTab from "./tabs/InterviewTab";
import RoadmapView from "./RoadmapView";

/**
 * CareerNavigator — page shell.
 *
 * Holds two pieces of state:
 *  - tab:     active tab id (default "home")
 *  - roadmap: { trackId, stage } | null — when set, RoadmapView replaces the
 *             tabs UI; clearing it (back/breadcrumb) returns to the active tab.
 */
export default function CareerNavigator() {
  const [tab, setTab] = useState("home");
  const [roadmap, setRoadmap] = useState(null);

  const handlePickRole = (trackId) => {
    setRoadmap({ trackId, stage: "leveling-up" });
  };

  // When a roadmap is set, render the per-track view in place of the tabs.
  if (roadmap) {
    return (
      <div className="min-h-screen" style={{ background: "#f7f8fa" }} data-testid="career-navigator-page">
        <NavHeader />
        <main className="mx-auto px-4 sm:px-6 py-8" style={{ maxWidth: 960 }}>
          <RoadmapView
            roadmap={roadmap}
            onBack={() => {
              setRoadmap(null);
              setTab("paths");
            }}
            onStage={(stageId) => setRoadmap((r) => (r ? { ...r, stage: stageId } : r))}
          />
        </main>
      </div>
    );
  }

  // Default hero props (shown for tabs that don't override).
  let heroProps = {
    eyebrow: "Career navigator",
    title: "Find your next move in Workday.",
    subtitle: "Pick a path, prep for interviews, and read the industry — all from one place.",
    rightPill: null,
    heroChildren: null,
  };

  if (tab === "home") {
    heroProps = {
      ...HomeTab.heroProps,
      heroChildren: <HomeTab.HeroContent onSetTab={setTab} onPickRole={handlePickRole} />,
    };
  } else if (tab === "paths") {
    heroProps = { ...PathsTab.heroProps, heroChildren: null };
  } else if (tab === "interview") {
    heroProps = { ...InterviewTab.heroProps, heroChildren: null };
  }

  return (
    <div className="min-h-screen" style={{ background: "#f7f8fa" }} data-testid="career-navigator-page">
      <NavHeader />
      <main className="mx-auto px-4 sm:px-6 py-8" style={{ maxWidth: 960 }}>
        <HeroMast
          eyebrow={heroProps.eyebrow}
          title={heroProps.title}
          subtitle={heroProps.subtitle}
          rightPill={heroProps.rightPill}
        >
          {heroProps.heroChildren}
        </HeroMast>
        <TabBar value={tab} onChange={setTab} />

        {tab === "home" && <HomeTab onSetTab={setTab} />}
        {tab === "paths" && (
          <PathsTab
            onPickTrack={(trackId, stage) => setRoadmap({ trackId, stage })}
          />
        )}
        {tab === "interview" && <InterviewTab />}

        {tab !== "home" && tab !== "paths" && tab !== "interview" && (
          <div
            className="mt-6 rounded-xl bg-white p-6 text-sm"
            style={{ border: "1px solid #eaeaea", color: "#555" }}
            data-testid="career-navigator-placeholder"
          >
            {tab}
          </div>
        )}
      </main>
    </div>
  );
}
